import axiosInstance from "@/api/axiosInstance";
import {
  UpdatePreEpChecklistItemRequest,
  UpdatePreEpChecklistItemResponse,
} from "./types";

/** Record that the member opened (did) one of the outside-site steps. */
export const updatePreEpChecklistItem = async ({
  item,
  done,
}: UpdatePreEpChecklistItemRequest): Promise<UpdatePreEpChecklistItemResponse> => {
  const response = await axiosInstance.post<UpdatePreEpChecklistItemResponse>(
    `/api/private/pre-ep/checklist/${item}`,
    { done },
  );

  return response.data;
};
